module.exports = __webpack_public_path__ + "static/img/picopico.775aa83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/picopico.png
// module id = 0ptw
// module chunks = 0